// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stops-modal .ant-modal-title {
  color: var(--eta-color-theme);
  font-weight: 400;
  font-size: 18px;
}
.stops-body {
  max-height: 600px;
  overflow-y: auto;
}
.stops-body::-webkit-scrollbar {
  width: 4px;
}
.stops-body::-webkit-scrollbar-track {
  background: transparent;
}
.stops-body::-webkit-scrollbar-thumb {
  background: var(--eta-border-color);
  border-radius: 2px;
}
.stops-body::-webkit-scrollbar-thumb:hover {
  background: var(--eta-color-theme);
}
.stops-body .title {
  color: var(--eta-color-theme);
  font-size: 22px;
  font-weight: 600;
}
.stops-body .stop-card {
  padding: 16px 24px;
  border-radius: 1em;
  border-width: 1px;
  border-style: solid;
  border-color: var(--eta-border-color);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 24px;
  color: var(--eta-color-theme);
  font-size: 18px;
}
.stops-body .stop-card[data-current="true"] {
  background: var(--etaeta-color-accent);
  border-width: 0;
}
.stops-body .stop-card .content p {
  margin: 0;
}
.stops-body .stop-card .content p:nth-child(1) {
  color: #0088ff;
  font-weight: 500;
}
.stops-body .stop-card .stop-map-link {
  margin-left: auto;
  color: var(--eta-color-theme);
}
/*# sourceMappingURL=StopsModal.css.map */`, "",{"version":3,"sources":["webpack://./StopsModal.less","webpack://./src/components/TransportList/components/StopsModal/StopsModal.less"],"names":[],"mappings":"AAAA;EAEQ,6BAAA;EACA,gBAAA;EACA,eAAA;ACAR;ADIA;EACI,iBAAA;EACA,gBAAA;ACFJ;ADII;EACI,UAAA;ACFR;ADKI;EACI,uBAAA;ACHR;ADMI;EACI,mCAAA;EACA,kBAAA;ACJR;ADMQ;EACI,kCAAA;ACJZ;ADbA;EAsBQ,6BAAA;EACA,eAAA;EACA,gBAAA;ACNR;ADlBA;EA4BQ,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;ACPR;ADSQ;EACI,sCAAA;EACA,eAAA;ACPZ;ADnCA;EA+CgB,SAAA;ACThB;ADWgB;EACI,cAAA;EACA,gBAAA;ACTpB;AD1CA;EAyDY,iBAAA;EACA,6BAAA;ACZZ;AACA,yCAAyC","sourcesContent":[".stops-modal {\n    .ant-modal-title {\n        color: var(--eta-color-theme);\n        font-weight: 400;\n        font-size: 18px;\n    }\n}\n\n.stops-body {\n    max-height: 600px;\n    overflow-y: auto;\n\n    &::-webkit-scrollbar {\n        width: 4px;\n    }\n\n    &::-webkit-scrollbar-track {\n        background: transparent;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background: var(--eta-border-color);\n        border-radius: 2px;\n\n        &:hover {\n            background: var(--eta-color-theme);\n        }\n    }\n\n    .title {\n        color: var(--eta-color-theme);\n        font-size: 22px;\n        font-weight: 600;\n    }\n\n    .stop-card {\n        padding: 16px 24px;\n        border-radius: 1em;\n        border-width: 1px;\n        border-style: solid;\n        border-color: var(--eta-border-color);\n        display: flex;\n        flex-flow: row nowrap;\n        align-items: center;\n        gap: 24px;\n        color: var(--eta-color-theme);\n        font-size: 18px;\n\n        &[data-current=\"true\"] {\n            background: var(--etaeta-color-accent);\n            border-width: 0;\n        }\n\n        .content {\n            p {\n                margin: 0;\n\n                &:nth-child(1) {\n                    color: #0088ff;\n                    font-weight: 500;\n                }\n            }\n        }\n\n        .stop-map-link {\n            margin-left: auto;\n            color: var(--eta-color-theme);\n        }\n\n    }\n}",".stops-modal .ant-modal-title {\n  color: var(--eta-color-theme);\n  font-weight: 400;\n  font-size: 18px;\n}\n.stops-body {\n  max-height: 600px;\n  overflow-y: auto;\n}\n.stops-body::-webkit-scrollbar {\n  width: 4px;\n}\n.stops-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.stops-body::-webkit-scrollbar-thumb {\n  background: var(--eta-border-color);\n  border-radius: 2px;\n}\n.stops-body::-webkit-scrollbar-thumb:hover {\n  background: var(--eta-color-theme);\n}\n.stops-body .title {\n  color: var(--eta-color-theme);\n  font-size: 22px;\n  font-weight: 600;\n}\n.stops-body .stop-card {\n  padding: 16px 24px;\n  border-radius: 1em;\n  border-width: 1px;\n  border-style: solid;\n  border-color: var(--eta-border-color);\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 24px;\n  color: var(--eta-color-theme);\n  font-size: 18px;\n}\n.stops-body .stop-card[data-current=\"true\"] {\n  background: var(--etaeta-color-accent);\n  border-width: 0;\n}\n.stops-body .stop-card .content p {\n  margin: 0;\n}\n.stops-body .stop-card .content p:nth-child(1) {\n  color: #0088ff;\n  font-weight: 500;\n}\n.stops-body .stop-card .stop-map-link {\n  margin-left: auto;\n  color: var(--eta-color-theme);\n}\n/*# sourceMappingURL=StopsModal.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
